import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PaymentTabItem {
  label: string;
  route: RoutesEnum;
}

const paymentPageTabs: PaymentTabItem[] = [
  {
    label: 'invoice:adminInvoiceGroupOverviewPage.tabInvoiceGroups',
    route: RoutesEnum.AdminInvoiceGroupSettings,
  },
  {
    label: 'invoice:adminInvoiceGroupOverviewPage.tabInvoiceTemplates',
    route: RoutesEnum.AdminInvoiceTemplateSettings,
  },
];

const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

export default function AdminInvoiceTabNavigation() {
  const { t } = useTranslation(['invoice']);
  const routeMatch = useRouteMatch(paymentPageTabs.map((x) => x.route)); // Order is important here, read documentation on MUI
  const currentTab = routeMatch?.pattern?.path;

  return (
    <>
      <Tabs value={currentTab}>
        {paymentPageTabs.map((item) => (
          <Tab label={t(item.label)} key={item.route} value={item.route} to={item.route} component={Link} />
        ))}
      </Tabs>
      <Divider />
    </>
  );
}
